import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getInsuranceInsuredsName from 'utils/print/getInsuranceInsuredsName';
import getInsuranceInsuredsFullDob from 'utils/print/getInsuranceInsuredsFullDob';
import getInsuranceID from 'utils/print/getInsuranceID';
import getOtherInsuranceNameID from 'utils/print/getOtherInsuranceNameID';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullPhone from 'utils/print/getPrescriberFullPhone';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getPrescriberFullFax from 'utils/print/getPrescriberFullFax';
import getPrescriberAddress from 'utils/print/getPrescriberAddress';
import getPrescriberCityState from 'utils/print/getPrescriberCityState';
import getPrescriberZip from 'utils/print/getPrescriberZip';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullPhone from 'utils/print/getSupplierFullPhone';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getSupplierFullFax from 'utils/print/getSupplierFullFax';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getFacilityZip from 'utils/print/getFacilityZip';
import getFacilityCityState from 'utils/print/getFacilityCityState';
import getInquiringProviderUserName from 'utils/print/getInquiringProviderUserName';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineDescription from 'utils/print/getOrderLineDescription';
import getOrderLineType from 'utils/print/getOrderLineType';
import getOrderLineDosFromTo from 'utils/print/getOrderLineDosFromTo';
import getCurrentDate from 'utils/print/getCurrentDate';

const PriorAuthorizationTemplateMetropolisAuthorizationRequest = {
  ID: 25,
  Name: 'Metropolis Authorization Request',
  Type: 'Prior Authorization Template',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 10,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Metropolis-Authorization-Request/1.js',
      fields: [
        {
          name: 'Phone',
          type: 'text',
          getValue: () => '(866) 679-1647',
          x: 171,
          y: 46,
          width: 30,
          normalize: normalize.phone,
        },
        {
          name: 'Fax',
          type: 'text',
          getValue: () => '(212) 908-5185',
          x: 171,
          y: 51,
          width: 30,
          normalize: normalize.phone,
        },
        {
          name: 'Date',
          type: 'text',
          getValue: getCurrentDate,
          x: 152,
          y: 66,
          width: 23,
          normalize: normalize.date,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 36,
          y: 82.5,
          width: 103,
        },
        {
          name: 'Patient DOB',
          type: 'text',
          getValue: getPatientFullDob,
          x: 152,
          y: 82.5,
          width: 23,
          normalize: normalize.date,
        },
        {
          name: 'Patient ID',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 25,
          y: 90,
          width: 57,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Policyholder Name',
          type: 'text',
          getValue: getInsuranceInsuredsName,
          x: 36,
          y: 114,
          width: 103,
        },
        {
          name: 'Policyholder DOB',
          type: 'text',
          getValue: getInsuranceInsuredsFullDob,
          x: 152,
          y: 114,
          width: 23,
          normalize: normalize.date,
        },
        {
          name: 'Policyholder ID',
          type: 'text',
          getValue: getInsuranceID,
          x: 25,
          y: 121,
          width: 57,
        },
        {
          name: 'Other Insurance',
          type: 'text',
          getValue: getOtherInsuranceNameID,
          x: 45,
          y: 133,
          width: 82,
        },
        {
          name: 'Is other insurance primary?',
          type: 'radio',
          options: [
            {
              x: 176,
              y: 133,
              width: 5,
              height: 5,
              value: 'Yes',
            },
            {
              x: 191,
              y: 133,
              width: 5,
              height: 5,
              value: 'No',
            },
          ],
        },
        {
          name: 'ORDERING PHYSICIAN Full Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 35,
          y: 161,
          width: 92,
        },
        {
          name: 'ORDERING PHYSICIAN Phone',
          type: 'text',
          getValue: getPrescriberFullPhone,
          x: 149,
          y: 161,
          width: 51,
          normalize: normalize.phone,
        },
        {
          name: 'ORDERING PHYSICIAN NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 30,
          y: 168,
          width: 97,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'ORDERING PHYSICIAN Fax',
          type: 'text',
          getValue: getPrescriberFullFax,
          x: 149,
          y: 168,
          width: 51,
          normalize: normalize.phone,
        },
        {
          name: 'ORDERING PHYSICIAN Address',
          type: 'text',
          getValue: getPrescriberAddress,
          x: 17,
          y: 181,
          width: 183,
        },
        {
          name: 'ORDERING PHYSICIAN City',
          type: 'text',
          getValue: getPrescriberCityState,
          x: 34,
          y: 189,
          width: 93,
        },
        {
          name: 'ORDERING PHYSICIAN Zip',
          type: 'text',
          getValue: getPrescriberZip,
          x: 148,
          y: 189,
          width: 52,
          normalize: normalize.zip,
        },
        {
          name: 'SERVICING PROVIDER Name',
          type: 'text',
          getValue: getSupplierName,
          x: 34,
          y: 211,
          width: 93,
        },
        {
          name: 'SERVICING PROVIDER Phone',
          type: 'text',
          getValue: getSupplierFullPhone,
          x: 148,
          y: 211,
          width: 52,
          normalize: normalize.phone,
        },
        {
          name: 'SERVICING PROVIDER NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 27,
          y: 221,
          width: 100,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Fax',
          type: 'text',
          getValue: getSupplierFullFax,
          x: 148,
          y: 221,
          width: 52,
          normalize: normalize.phone,
        },
        {
          name: 'SERVICING PROVIDER Address',
          type: 'text',
          getValue: getFacilityStreet,
          x: 18,
          y: 237,
          width: 183,
        },
        {
          name: 'SERVICING PROVIDER City State',
          type: 'text',
          getValue: getFacilityCityState,
          x: 34,
          y: 247,
          width: 93,
          normalize: normalize.zip,
        },
        {
          name: 'SERVICING PROVIDER Zip',
          type: 'text',
          getValue: getFacilityZip,
          x: 146,
          y: 247,
          width: 52,
          normalize: normalize.zip,
        },
        {
          name: 'SERVICING PROVIDER Contact Name',
          type: 'text',
          getValue: getInquiringProviderUserName,
          x: 41,
          y: 256,
          width: 86,
        },
        {
          name: 'SERVICING PROVIDER Phone 2',
          type: 'text',
          getValue: getSupplierFullPhone,
          x: 146,
          y: 256,
          width: 52,
          normalize: normalize.phone,
        },
      ],
    },
    {
      ID: 2,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Metropolis-Authorization-Request/2.js',
      fields: [
        {
          name: 'Patient Name 2',
          type: 'text',
          getValue: getPatientName,
          x: 40,
          y: 40,
          width: 158,
        },
        {
          name: 'Is this an Urgent Request?',
          type: 'radio',
          options: [
            {
              x: 64,
              y: 46,
              width: 5,
              height: 5,
              value: 'Yes',
            },
            {
              x: 82,
              y: 46,
              width: 5,
              height: 5,
              value: 'No',
            },
          ],
        },
        {
          name: 'If yes, indicate why',
          type: 'text',
          x: 49,
          y: 55,
          width: 150,
        },
        {
          name: 'Diagnoses',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 35,
          y: 62,
          width: 164,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].reduce((accumulator, currentValue) => {
          const y = 94 + (currentValue * 6.5);
          return [
            ...accumulator,
            {
              name: `HCPC Code ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 14,
              y,
              width: 25,
            },
            {
              name: `Service Description ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDescription({ ...props, index: currentValue }),
              x: 41,
              y,
              width: 62,
            },
            {
              name: `Qty ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 105,
              y,
              width: 29,
              normalize: normalize.number,
            },
            {
              name: `Type ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineType({ ...props, index: currentValue }),
              x: 136,
              y,
              width: 27,
            },
            {
              name: `DOS From To ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosFromTo({ ...props, index: currentValue }),
              x: 165,
              y,
              width: 39,
            },
          ];
        }, []),
        {
          name: 'Additional Details (if necessary)',
          type: 'text',
          x: 13,
          y: 167,
          width: 192,
          height: 70,
          multiline: true,
        },
      ],
    },
  ],
};

export default PriorAuthorizationTemplateMetropolisAuthorizationRequest;



// WEBPACK FOOTER //
// ./src/config/documents/Prior-Authorization-Template-Metropolis-Authorization-Request.js